var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGa = function SvgIconGa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M23.254 16.175c.482-1.3.746-2.706.746-4.174s-.264-2.874-.746-4.174L12 6.784.746 7.827A12 12 0 0 0 0 12.001c0 1.468.264 2.874.746 4.174L12 17.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c5.16 0 9.559-3.257 11.254-7.827H.747C2.443 20.743 6.841 24 12.001 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12 .001C6.842.001 2.444 3.257.748 7.827h22.507C21.56 3.257 17.16.001 12.001.001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGa;